export const notificationErrors = (err) => {
  if (err?.errors) {
    const { type, msg } = err.errors[0]
    if (type && msg) {
      // console.log('notificationErrors:', type, err)
      if (type == "RequireLoginError") {
        // 導頁登入
        swal.fire({
          title: msg,
          type: 'error',
          confirmButtonText: '立即登入',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.value) {
            window.location.href = "/login";
          } 
        })
      } else {
        swal.fire(type, msg, "error");
      }
    } else {
      swal.fire(err.errors[0], "", "error");
    }
  } else {
    console.log('notificationErrors:', err)
  }
}

export const apiErrorText = (text) => {
  return {
    response: {
      data: {
        errors: [text],
      },
    },
  }
}
